const LOCALES = {
    "en-US": "English (US)",
    "sv-FI": "Swedish (Finland)",
    "fi-FI": "Finnish (Finland)",
    "fa-IR": "Persian (Iran)",
}
export default LOCALES;
